export enum ROUNDING_BEHAVIOR {
  NONE = 0,
  UP = 1,
  DOWN = 2,
}
